import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=070ccaa2&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=070ccaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ccaa2",
  null
  
)

export default component.exports